import { render, staticRenderFns } from "./BlankLayout.vue?vue&type=template&id=5291c0af&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291c0af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5291c0af')) {
      api.createRecord('5291c0af', component.options)
    } else {
      api.reload('5291c0af', component.options)
    }
    module.hot.accept("./BlankLayout.vue?vue&type=template&id=5291c0af&scoped=true", function () {
      api.rerender('5291c0af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/BlankLayout.vue"
export default component.exports